import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing Supabase environment variables. " +
      "Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file."
  );
}

// Re-exported so the keepalive flush helper (src/lib/keepaliveRest.ts) can
// build raw PostgREST URLs without re-reading import.meta.env at call time
// (which doesn't work after the page is being unloaded on pagehide).
export const SUPABASE_URL: string = supabaseUrl;
export const SUPABASE_ANON_KEY: string = supabaseAnonKey;

// Cypress injects `window.Cypress` into the app-under-test's window before any
// app code runs. GoTrueClient starts its background session-refresh interval
// synchronously in its own constructor — i.e. the moment this module is first
// imported, before any test gets a chance to run. That's a real, native
// `setInterval` that no test's `cy.clock()` can retroactively fake: sinon's
// fake timers only intercept calls made after they're installed, and this one
// is already registered against the real clock by then. The ticker runs for
// the whole spec file's duration and, on every tick, acquires the same lock
// every other authenticated Supabase call goes through — if a tick lands at
// the wrong moment relative to a test that's faking time, that lock can wedge
// and silently swallow every request the test is waiting on (see AVIV-325).
// Component tests fake their own auth via cy.stub()/interceptSupabase(), so
// there's no real session to keep refreshed — turn the ticker off entirely.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { autoRefreshToken: !window.Cypress },
});
